import React from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";

const RewardCenter = () => {
  const navigate = useNavigate();  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="reward-center-container">
        <div className="reward-center">
          <div className="mc-header-wrap">
            <div
              id="mc-header"
              className="mc-navbar-blue mc-rewardCenter mc-default-header am-navbar am-navbar-light"
            >
              <div
                onClick={() => navigate(-1)}
                className="am-navbar-left"
                role="button"
              >
                <span className="am-navbar-left-content">
                  <span className="return_icon">
                    <svg className="am-icon am-icon-left am-icon-lg">
                      <use xlinkHref="#left" />
                    </svg>
                  </span>
                </span>
              </div>
              <div style={{ color: "white" }} className="am-navbar-title">
                Reward Center
              </div>
              <div className="am-navbar-right" />
            </div>
            <div className="am-whitespace am-whitespace-sm mc-whitespace" />
          </div>
          <div
            className="common-center-top false false"
            style={{
              "background-image":
                'url("/assets/images/border.b5fa93b3.png"), url("/assets/images/badge.bf45a271.png"), linear-gradient(30deg, rgb(179, 188, 200), rgb(241, 249, 255))',
            }}
          >
            <div />
            <div className="common-member-info ">
              <div className="common-top-img">
                <div className="profile-icon">
                  <img
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/B2C/01_PROFILE/PROFILE/0.png"
                    alt
                  />
                </div>
              </div>
              <div className="user-info">
                <div className="user-name">
                  <div className="copy-account">
                    <span>{user?.user?.username}</span>
                    <svg className="am-icon am-icon-icon-copy_17d4102f am-icon-md">
                      <use xlinkHref="#icon-copy_17d4102f" />
                    </svg>
                  </div>
                </div>
                <div className="nickname-edit">
                  <div className="nickname-info">
                    <span className="info-title">
                      {/* react-text: 11844 */}Nickname{/* /react-text */}
                      {/* react-text: 11845 */}: {/* /react-text */}
                    </span>
                    <span className="name-text">{user?.user?.username}</span>
                  </div>
                  <a className="go-to-edit" href="/m/myAccount/nickName">
                    <svg className="am-icon am-icon-icon-edit_68c0ffef am-icon-md">
                      <use xlinkHref="#icon-edit_68c0ffef" />
                    </svg>
                  </a>
                </div>
                <div className="false amount-info">
                  <div className="amount-balance-common ">
                    <span className="currency ">৳</span>
                    {/* react-text: 11853 */}&nbsp;{/* /react-text */}
                    <span className="number-mc undefined">0.00</span>
                  </div>
                  <svg className="am-icon am-icon-refresh_e506c375 am-icon-md false refresh-balance">
                    <use xlinkHref="#refresh_e506c375" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="common-member-level">
              <div className="level-top">
                <div className="member-level-name false">VIP0</div>
                <div className="quanyi-go">
                  <div>Benefits</div>
                </div>
              </div>
              <div className="member-progress-warp">
                <div className="member-level-progress-bar">
                  <div className="cur-progress-bar" style={{ width: "0%" }} />
                </div>
                <div className="level-progress-text">0 / 2</div>
              </div>
            </div>
          </div>
          <div className="task-list-warp">
            <div
              onClick={() => navigate("/member/bonus")}
              className="false task-list-item"
            >
              <img
                src="/assets/images/gift_bg.e5aebbb5.png"
                alt="receiving_center"
                className="item-bg"
              />
              <div className="receiving_center item-icon">
                <img
                  src="/assets/images/gift_icon.f6429730.png"
                  alt="receiving_center"
                />
                <span className="ticket-count">
                  <i>2</i>
                </span>
              </div>
              <div className="task-list-title">
                <div>
                  {/* react-text: 11871 */} {/* /react-text */}
                  {/* react-text: 11872 */}Bonus{/* /react-text */}
                </div>
              </div>
            </div>
            <div className="true task-list-item">
              <img
                src="/assets/images/money_bg.31139bae.png"
                alt="rescue_fund"
                className="item-bg"
              />
              <div className="rescue_fund item-icon">
                <img
                  src="/assets/images/money_icon.578db6fe.png"
                  alt="rescue_fund"
                />
              </div>
              <div className="task-list-title">
                <div>
                  {/* react-text: 11879 */} {/* /react-text */}
                  {/* react-text: 11880 */}Rescue fund{/* /react-text */}
                </div>
              </div>
            </div>
            <div
              onClick={() => navigate("/member/inviteFriends")}
              className="false task-list-item"
            >
              <img
                src="/assets/images/invite_bg.d4ec0a70.png"
                alt="invite_friends"
                className="item-bg"
              />
              <div className="invite_friends item-icon">
                <img
                  src="/assets/images/invite_icon.bad8d6b3.png"
                  alt="invite_friends"
                />
              </div>
              <div className="task-list-title">
                <div>
                  {/* react-text: 11887 */} {/* /react-text */}
                  {/* react-text: 11888 */}Invite Friends{/* /react-text */}
                </div>
              </div>
            </div>
            <div
              onClick={() => navigate("/member/temuTicket")}
              className="false task-list-item"
            >
              <img
                src="/assets/images/temu_bg.71dc064e.png"
                alt="label_temu"
                className="item-bg"
              />
              <div className="label_temu item-icon">
                <img
                  src="/assets/images/temu_icon.eed816b6.png"
                  alt="label_temu"
                />
              </div>
              <div className="task-list-title">
                <div>
                  {/* react-text: 11895 */} {/* /react-text */}
                  {/* react-text: 11896 */}TEMU Ticket{/* /react-text */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardCenter;
